import React from 'react'
import SearchPage from '../../src/SearchPage'
import LayoutFirebase from '../../src/LayoutFirebase'
import MetaTags from "../../src/MetaTags"
import { useRouter } from "next/router"
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { findResultsState } from 'react-instantsearch-dom/server';
import Search, {searchClient} from "../../src/Search"
import Loading from "../../src/Loading"
import { getIndexKeywords } from "../../SEO/queries"

const SearchSite = ({resultsState, searchState, firstHitImage, totalHits}) => {
    const router = useRouter()
    const { basePath } = router
    const { t } = useTranslation()

    if (router.isFallback) {
      return <Loading minHeightScreen />
    }

    const formattedQuery = searchState.query.charAt(0).toUpperCase() + searchState.query.slice(1)
    const pageTitle = `${formattedQuery} - ${t("search.title")} (${totalHits} results)`
    const pageDescription = `${formattedQuery}. ${t('search.description')} ${totalHits} results.`

    return (
    <>
    <MetaTags
        title={pageTitle}
        description={pageDescription}
        image={firstHitImage || `${basePath}/assets/Moebel-Suche.jpg`}
      />
    <LayoutFirebase>
        <SearchPage 
          resultsState={JSON.parse(resultsState)}
          searchState={searchState}
        />
    </LayoutFirebase>
    </>
)}
export default SearchSite

export const getStaticProps = async ({ locale, params }) => {
  const { query } = params
  const DEFAULT_PROPS = {
    searchClient,
    indexName: locale == "en" ? "us" : "de",
  }

  const searchState = {
    query: query?.replace(/-/g, ' ')
  }

  const resultsState = await findResultsState(Search, {
    ...DEFAULT_PROPS,
    searchState,
  })

  const firstHitImage = resultsState.rawResults?.[0]?.hits?.[0]?.image || null
  const totalHits = resultsState.rawResults?.[0]?.nbHits || 0

  return {
    props: {
      ...(await serverSideTranslations(locale)),
      resultsState: JSON.stringify(resultsState),
      searchState,
      firstHitImage,
      totalHits
    },
    revalidate: 86400, // daily (24 hours)
  }
}

export async function getStaticPaths() {
  return {
    paths: getIndexKeywords().map(q => `/furniture/${q.replace(/ /g, '-')}`).slice(0, process.env.STATIC_LIMIT),
    fallback: 'blocking',
  }
}